import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              {t('footer.about')}
            </h4>
            <div className="w-8 h-px bg-primary-500/50 mb-4"></div>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  {t('footer.about')}
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  {t('footer.contact')}
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  {t('footer.faq')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              {t('nav.category')}
            </h4>
            <div className="w-8 h-px bg-primary-500/50 mb-4"></div>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              {t('footer.legal')}
            </h4>
            <div className="w-8 h-px bg-primary-500/50 mb-4"></div>
            <ul className="space-y-2.5">
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  {t('footer.privacy')}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  {t('footer.terms')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              {t('footer.follow')}
            </h4>
            <div className="w-8 h-px bg-primary-500/50 mb-4"></div>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-50 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-background-50 text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-10 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <p className="text-2xl md:text-3xl font-heading font-black text-background-100 whitespace-nowrap">
                八仔漫画网
              </p>
              <div className="w-12 h-0.5 bg-primary-500/40 mt-1 mb-3"></div>
              <p className="text-xs text-background-400 max-w-md">
                {t('footer.brandDesc')}
              </p>
            </div>
            <p className="text-xs text-background-500 whitespace-nowrap">
              {t('footer.copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}